/**
 * Entrée i18n de l'app form-polls (DooQuest).
 * Importe la config partagée (core) puis enregistre les namespaces :
 *   - `forms` : strings form-polls spécifiques
 *   - `polls` : strings core partagées (QuestionCard, DashboardFilters, etc.)
 */
import i18n, { registerNamespace } from "@core/i18n";

import frForms from "./locales/fr/forms.json";
import enForms from "./locales/en/forms.json";
import esForms from "./locales/es/forms.json";

import frPolls from "@core/i18n/locales/fr/polls.json";
import enPolls from "@core/i18n/locales/en/polls.json";
import esPolls from "@core/i18n/locales/es/polls.json";

registerNamespace("forms", { fr: frForms, en: enForms, es: esForms });
registerNamespace("polls", { fr: frPolls, en: enPolls, es: esPolls });

export default i18n;
